import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import Reveal from "../ui/Reveal";
import SectionLabel from "../ui/SectionLabel";
import { Tags } from "../ui/Tag";
import { experience } from "../../data/experience";

function Experience() {
  return (
    <Section id="experience" aria-labelledby="experience-heading">
      <ExperienceIntro>
        <div>
          <SectionLabel>Experience</SectionLabel>
          <h2 id="experience-heading">Learning by shipping.</h2>
        </div>
        <p>Real-world MERN and Angular experience across production interfaces and internal platforms.</p>
      </ExperienceIntro>
      <Timeline>
        {experience.map((item, index) => (
          <Reveal as="div" delay={index * 0.08} key={item.company}>
            <ExperienceCard>
              <div className="period">{item.period}</div>
              <div>
                <span className="index">0{index + 1}</span>
                <h3>{item.role}</h3>
                <h4>
                  {item.companyUrl ? (
                    <a href={item.companyUrl} target="_blank" rel="noreferrer">
                      {item.company} <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                    </a>
                  ) : (
                    item.company
                  )}
                </h4>
                <ul>
                  {item.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
                <Tags items={item.tags} />
              </div>
            </ExperienceCard>
          </Reveal>
        ))}
      </Timeline>
    </Section>
  );
}

const Section = styled.section`
  max-width: 1240px;
  margin: auto;
  padding: 100px 28px;

  @media (max-width: 700px) {
    padding: 70px 24px;
  }
`;

const ExperienceIntro = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 40px;
  align-items: end;
  margin-bottom: 55px;

  h2 {
    font-size: clamp(2.1rem, 4vw, 3.4rem);
    letter-spacing: -0.03em;
    line-height: 1.05;
    color: var(--text-primary);
    margin: 0;
  }

  p {
    color: var(--text-secondary);
    max-width: 340px;
    line-height: 1.6;
    margin: 0;
    font-size: 0.95rem;
  }

  @media (max-width: 700px) {
    display: block;
    p {
      margin-top: 22px;
    }
  }
`;

const Timeline = styled.div`
  border-top: 1px solid var(--border);
`;

const ExperienceCard = styled.article`
  display: grid;
  grid-template-columns: 22% 1fr;
  gap: 30px;
  padding: 34px 0;
  border-bottom: 1px solid var(--border);

  .period {
    font-size: 0.75rem;
    color: var(--text-muted);
    font-weight: 700;
    padding-top: 5px;
  }

  .index {
    font-size: 0.65rem;
    color: var(--accent);
    font-weight: 800;
  }

  h3 {
    font-size: 1.4rem;
    letter-spacing: -0.02em;
    color: var(--text-primary);
    margin: 8px 0 2px;
  }

  h4 {
    margin: 0;
    font-size: 0.9rem;
    font-weight: 600;

    a {
      color: var(--accent);
      text-decoration: none;
    }

    a:hover {
      text-decoration: underline;
    }
  }

  ul {
    margin: 16px 0 0;
    padding-left: 18px;
    color: var(--text-secondary);
    font-size: 0.92rem;
    line-height: 1.65;
    max-width: 700px;
  }

  li + li {
    margin-top: 6px;
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
    gap: 8px;
  }
`;

export default Experience;
